import { calmTokens as t } from '../../shared/tokens';
import { fmtEUR } from '../../shared/format';
import { fmtRecurrenceShort } from '../../shared/recurrence';
import {
  IconArrowDown,
  IconArrowUp,
  IconEdit,
  IconTrash,
} from '../../shared/icons';

export default function SettingsTplCard({
  tpl,
  onEdit,
  onToggle,
  onDelete,
  showDay = true,
}) {
  const isDebit = tpl.type === 'debit';

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '36px minmax(0, 1fr) auto auto auto',
        alignItems: 'center',
        gap: 14,
        padding: '14px 20px',
        opacity: tpl.isActive ? 1 : 0.55,
        transition: 'opacity .15s',
      }}
    >
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: 10,
          background: isDebit ? t.debitDim : t.creditDim,
          border: `1px solid ${isDebit ? t.debitBorder : t.creditBorder}`,
          display: 'grid',
          placeItems: 'center',
          color: isDebit ? t.debit : t.credit,
        }}
        aria-hidden="true"
      >
        {isDebit ? <IconArrowUp size={15} /> : <IconArrowDown size={15} />}
      </div>

      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontSize: 14,
            fontWeight: 500,
            letterSpacing: -0.15,
            color: t.text,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={tpl.title}
        >
          {tpl.title}
        </div>
        <div
          style={{
            fontSize: 11,
            color: t.textMute,
            marginTop: 3,
            display: 'flex',
            gap: 8,
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          <span>{fmtRecurrenceShort(tpl.recurrencePattern)}</span>
          {showDay && tpl.dayOfMonth != null && (
            <>
              <span style={{ opacity: 0.4 }}>·</span>
              <span style={{ fontFamily: t.fontMono, letterSpacing: -0.1 }}>
                le {String(tpl.dayOfMonth).padStart(2, '0')}
              </span>
            </>
          )}
        </div>
      </div>

      <div
        style={{
          fontFamily: t.fontMono,
          fontSize: 15,
          fontWeight: 500,
          color: isDebit ? t.debit : t.credit,
          letterSpacing: -0.3,
          fontVariantNumeric: 'tabular-nums',
          whiteSpace: 'nowrap',
        }}
      >
        {isDebit ? '− ' : '+ '}
        {fmtEUR(tpl.amount)}
      </div>

      <button
        type="button"
        onClick={onToggle}
        title={tpl.isActive ? 'Mettre en pause' : 'Activer'}
        style={{
          padding: '5px 12px',
          borderRadius: 999,
          fontSize: 11,
          fontWeight: 500,
          background: tpl.isActive ? 'rgba(134,239,172,0.10)' : 'rgba(255,255,255,0.04)',
          color: tpl.isActive ? t.credit : t.textMute,
          border: `1px solid ${tpl.isActive ? 'rgba(134,239,172,0.25)' : t.border}`,
          cursor: 'pointer',
          fontFamily: t.fontUi,
          letterSpacing: -0.1,
          transition: 'all .15s',
        }}
      >
        {tpl.isActive ? 'Actif' : 'En pause'}
      </button>

      <div style={{ display: 'flex', gap: 4 }}>
        <button
          type="button"
          onClick={onEdit}
          title="Modifier"
          aria-label="Modifier la récurrente"
          style={{
            width: 30,
            height: 30,
            borderRadius: 8,
            background: 'transparent',
            border: `1px solid ${t.border}`,
            color: t.textDim,
            cursor: 'pointer',
            display: 'grid',
            placeItems: 'center',
            padding: 0,
            transition: 'all .15s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = t.accentSoft;
            e.currentTarget.style.borderColor = t.borderS;
            e.currentTarget.style.background = t.accentDim;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = t.textDim;
            e.currentTarget.style.borderColor = t.border;
            e.currentTarget.style.background = 'transparent';
          }}
        >
          <IconEdit size={13} />
        </button>
        <button
          type="button"
          onClick={onDelete}
          title="Supprimer"
          aria-label="Supprimer la récurrente"
          style={{
            width: 30,
            height: 30,
            borderRadius: 8,
            background: 'transparent',
            border: `1px solid ${t.border}`,
            color: t.textDim,
            cursor: 'pointer',
            display: 'grid',
            placeItems: 'center',
            padding: 0,
            transition: 'all .15s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = t.debit;
            e.currentTarget.style.borderColor = t.debitBorder;
            e.currentTarget.style.background = t.debitDim;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = t.textDim;
            e.currentTarget.style.borderColor = t.border;
            e.currentTarget.style.background = 'transparent';
          }}
        >
          <IconTrash size={13} />
        </button>
      </div>
    </div>
  );
}
